import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
type PaymentFormFrequencyProps = {
  paymentRecurring: boolean;
  setPaymentRecurring: (value: boolean) => void;
  setPaymentType: (paymentType: 'stripe' | 'paypal') => void;
};
export function PaymentFormFrequency(t0) {
  const $ = _c(28);
  const {
    paymentRecurring,
    setPaymentRecurring,
    setPaymentType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="mb-5 text-center text-xs uppercase tracking-[0.04rem] opacity-80">Choose donation frequency</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = paymentRecurring ? "opacity-50" : "opacity-100";
  let t3;
  if ($[1] !== t2) {
    t3 = cn("justify-self-end text-right leading-none max-[640px]:leading-normal", t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="mb-1.5 block font-semibold text-xl uppercase tracking-[0.02rem] max-[440px]:text-base">One time payment</span>;
    t5 = <span className="block text-xs tracking-[0.02rem] max-[640px]:hidden">One payment only</span>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[5] = t3;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== paymentRecurring || $[8] !== setPaymentRecurring || $[9] !== setPaymentType) {
    t7 = () => {
      setPaymentRecurring(!paymentRecurring);
      setPaymentType("stripe");
    };
    $[7] = paymentRecurring;
    $[8] = setPaymentRecurring;
    $[9] = setPaymentType;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = paymentRecurring && "translate-x-[52px]";
  let t9;
  if ($[11] !== t8) {
    t9 = cn("block h-[42px] w-[42px] rounded-full bg-black transition-transform duration-500 ease-in-out", t8);
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <span className="flex h-12 w-[100px] items-center rounded-[60px] bg-christ-white-900 p-[3px]"><span className={t9} /></span>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7) {
    t11 = <div className="justify-self-center"><button type="button" onClick={t7}>{t10}</button></div>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = paymentRecurring ? "opacity-100" : "opacity-50";
  let t13;
  if ($[18] !== t12) {
    t13 = cn("leading-none max-[640px]:leading-normal", t12);
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="mb-1.5 block font-semibold text-xl uppercase tracking-[0.02rem] max-[440px]:text-base">Monthly Payment</span>;
    t15 = <span className="block text-xs tracking-[0.02rem] max-[640px]:hidden">Maximise impact</span>;
    $[20] = t14;
    $[21] = t15;
  } else {
    t14 = $[20];
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t13) {
    t16 = <div className={t13}>{t14}{t15}</div>;
    $[22] = t13;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t11 || $[25] !== t16 || $[26] !== t6) {
    t17 = <div className="mb-12">{t1}<div className="grid grid-cols-[1fr_auto_1fr] items-center gap-4">{t6}{t11}{t16}</div></div>;
    $[24] = t11;
    $[25] = t16;
    $[26] = t6;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
}